/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://jnkntkpntbhadhuyagz6szluau.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-voyim2uusfesvjtxzxwmkxtbjy",
    "aws_cognito_identity_pool_id": "us-east-1:ead15b96-9736-4766-8a38-5081d2404dbe",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_6DlVUGEEI",
    "aws_user_pools_web_client_id": "5k3dea7a0fk63lmd9agc2b0ic1",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "geo": {
        "amazon_location_service": {
            "region": "us-east-1",
            "maps": {
                "items": {
                    "map2333a2b9-dev": {
                        "style": "VectorEsriStreets"
                    }
                },
                "default": "map2333a2b9-dev"
            }
        }
    }
};


export default awsmobile;
